import { Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ConvertToString from "../../../../../../components/Converter";
import AlertBox from "../../../../../../components/Messages";
import { RowBody } from "../../../../../../components/RowValue/RowBody";
import { ResultSpan } from "../../../../../../components/styledComponents/Result";
import ToolTip, { IconType } from "../../../../../../components/ToolTip";
import { useGetTraggliedDatenQuery } from "../../../../../../services/API/titanApi";
import {
  selectIsUtilizationFactorValid_Ermuedung,
  selectBerechneKnickenDinEN1993,
} from "../../../../../../store/slices/innereSlice";
import { selectTraggliedTitle } from "../../../../../../store/slices/traggliedSlice";

function Ausnutzung() {
  const { t } = useTranslation("translation");

  const tragglied = useSelector(selectTraggliedTitle);
  const { data: traggliedDaten } = useGetTraggliedDatenQuery(tragglied);
  const berechneteWerte = useSelector(selectBerechneKnickenDinEN1993(traggliedDaten));

  const isUtilizationFactorValid =
    berechneteWerte?.ausnutzung > 0 && berechneteWerte?.ausnutzung <= 1;

  const isValid = useSelector(selectIsUtilizationFactorValid_Ermuedung(traggliedDaten));

  const AusnutzungFormula = `\\displaystyle \\eta = \\frac{F_{d}}{N_{b,Rd}}`;
  let error = t("inner.biggerDesignLoad");
  return (
    <>
      <RowBody
        titleValue={<p>{t("inner.buckling.dinEN1993.verification.utilizationFactor")}</p>}
        formulaValue={
          <ToolTip id={"AusnutzungFormula"} type={IconType.FORMULA} formula={AusnutzungFormula} />
        }
        indicesValue={<span>&eta;</span>}
        inputValue={
          <ResultSpan valid={isUtilizationFactorValid} className="input">
            {ConvertToString(berechneteWerte?.ausnutzung, 2)}
          </ResultSpan>
        }
      />
      <Col md={8}>
        <AlertBox show={!isValid || !isUtilizationFactorValid} message={error} />
      </Col>
    </>
  );
}

export default Ausnutzung;
